import { FC, useRef } from 'react';

import { Button } from '@shared/components/Button';
import { TextField } from '@shared/components/TextField';
import { useAuth } from '@shared/state/hooks/useAuth';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useTitleHook } from '../hooks/useTitleHook';

interface ChangePasswordForm {
  presentPassword: string;
  password: string;
  passwordValidataion: string;
}

const UserChangePasswordPage: FC = function UserChangePasswordPage() {
  useTitleHook('비밀번호 변경');
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<ChangePasswordForm>();
  const { patchMePassword, refreshUserProfile, userProfile } = useAuth();
  const navigate = useNavigate();
  const weakPassword = userProfile?.security?.isWeakPassword === true;

  const password = useRef({});
  password.current = watch('password', '');

  const onSubmit: SubmitHandler<ChangePasswordForm> = async (data) => {
    //* 실패(취약 비밀번호 400 등)면 안내 토스트가 뜨고 이 화면에 남는다 — 예전엔 실패해도 홈으로 갔다
    const ok = await patchMePassword(data.password);
    if (!ok) return;
    //* 취약 판정이 서버에서 갱신되므로 프로필을 다시 읽어 사이드바 배지를 지운다
    await refreshUserProfile();
    navigate('/');
  };

  const showAlert = () => {
    if (Object.keys(errors).length > 0) {
      alert(Object.values(errors)[0]?.message);
    }
  };

  return (
    <div className="space-y-3 py-3 text-sm">
      <div className="space-y-4 p-8 theme-bg-1">
        <h5 className="font-bold theme-text-1">비밀번호 변경</h5>
        {weakPassword && (
          <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs leading-5 text-red-700">
            현재 비밀번호가 취약합니다. 기본값·연속·반복 숫자·아이디와 같은 값은 피해 주세요.
          </p>
        )}
        {/* <TextField
          placeholder="현재 비밀번호"
          className="w-full"
          type="password"
          {...register('presentPassword')}
        ></TextField> */}
        <div className="space-y-1">
          <TextField
            type="password"
            placeholder="새 비밀번호"
            className="w-full"
            {...register('password', {
              required: {
                value: true,
                message: '비밀번호를 입력해주세요.',
              },
              minLength: {
                value: 4,
                message: '4~16자리의 비밀번호를 입력해주세요.',
              },
              maxLength: {
                value: 16,
                message: '4~16자리의 비밀번호를 입력해주세요.',
              },
            })}
          ></TextField>
          <TextField
            type="password"
            placeholder="새 비밀번호 확인"
            className="w-full"
            {...register('passwordValidataion', {
              validate: (value) =>
                value === password.current ||
                '새 비밀번호와 비밀번호 확인이 일치하지 않습니다.',
            })}
          ></TextField>
        </div>

        <div className="space-y-2 pt-4">
          <Button
            className="button-rectangle theme-text-3 theme-bg-main"
            onClick={handleSubmit(onSubmit, showAlert)}
          >
            확인
          </Button>
          <Button
            type="button"
            className="button-rectangle border theme-border-3"
            onClick={() => {
              navigate(-1);
            }}
          >
            취소
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserChangePasswordPage;
